import PaymnetStore from "../../../store/paymnet-store";
import {createPlan} from "../createPlan";
import UserStore from "../../../store/user-store";
import {apiClient} from "../../../AxiosConfig";

export const TelegramPayment = async (planId, langCode, configId) => {
    const TG_WEB_APP = window.Telegram.WebApp

    const tgInvoiceHandler = (event) => {
        if (event.status === 'paid') {
            createPlan()
            PaymnetStore.setPaymentStatus('paid')
        } else {
            PaymnetStore.setPaymentProcessed(false)
        }
    }

    window.Telegram.WebApp.onEvent('invoiceClosed', tgInvoiceHandler);

    const body = {
        plan_id: planId,
        lang_code: langCode,
        plan_config_id :configId
    }

    if (UserStore.partnerId) body.partner_id = UserStore.partnerId;

    apiClient.post(`/v1/invoices/stars-invoice`, body).then((data => {
            PaymnetStore.setTxId(data.data.tx_id)
            TG_WEB_APP.openInvoice(data?.data?.invoice_link)

        })
    )

};
